var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDigit5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 90,
  height: 90,
  viewBox: "0 0 90 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M53.45 36.246H42.84v4.692c.454-.499 1.088-.907 1.904-1.224a7.255 7.255 0 0 1 2.652-.476c1.7 0 3.106.385 4.216 1.156 1.134.77 1.961 1.768 2.482 2.992.522 1.224.782 2.55.782 3.978 0 2.652-.748 4.76-2.244 6.324C51.137 55.229 49.03 56 46.31 56c-1.813 0-3.388-.306-4.726-.918-1.337-.635-2.368-1.507-3.094-2.618-.725-1.11-1.122-2.391-1.19-3.842h5.678a3.14 3.14 0 0 0 .986 1.768c.522.453 1.236.68 2.142.68 1.066 0 1.859-.34 2.38-1.02.522-.68.782-1.587.782-2.72 0-1.11-.272-1.96-.816-2.55-.544-.59-1.337-.884-2.38-.884-.77 0-1.405.193-1.904.578-.498.363-.827.85-.986 1.462h-5.61v-14.79H53.45v5.1Z",
  fill: "#000"
})));
export default SvgDigit5;